import styled from 'styled-components';

export const Content = styled.div`
  font-size: 16px;
  line-height: normal;
`;

export const Item = styled.div`
  margin: 0 0 3px;
  display: flex;
`;

export const Name = styled.div`
  color: #aaa;
  width: 150px;
`;

export const Value = styled.div`
  color: #fff;
  a {
    color: #fff;
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
`;
